import { render, staticRenderFns } from "./compulsoryCourses.vue?vue&type=template&id=73cb5536"
import script from "./compulsoryCourses.vue?vue&type=script&lang=js"
export * from "./compulsoryCourses.vue?vue&type=script&lang=js"
import style0 from "./compulsoryCourses.vue?vue&type=style&index=0&id=73cb5536&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports